import 'css-chunksrc/client/scenes/projectReport/textFieldsForm/styles.scss';export default {
  "textFieldsForm": "_textFieldsForm_1r1zj_1",
  "input": "_input_1r1zj_5",
  "criteriaInput": "_criteriaInput_1r1zj_9",
  "fullWidth": "_fullWidth_1r1zj_9",
  "subTitle": "_subTitle_1r1zj_16",
  "textarea": "_textarea_1r1zj_22",
  "content": "_content_1r1zj_34"
};